// ═══════════════════════════════════════════════════════════════════
//  modules/documents/utils.js
//  nextEcheanceFront · catColor · fileIcon
// ═══════════════════════════════════════════════════════════════════

import { THEME } from "../../socle/theme";

// Calcule la prochaine échéance (date + période) — pour pré-remplir le formulaire
export function nextEcheanceFront(dateStr, recurrence){
  const d=new Date(dateStr); if(isNaN(d.getTime())) return "";
  if(recurrence==="hebdomadaire") d.setDate(d.getDate()+7);
  else if(recurrence==="mensuel") d.setMonth(d.getMonth()+1);
  else if(recurrence==="trimestriel") d.setMonth(d.getMonth()+3);
  else if(recurrence==="semestriel") d.setMonth(d.getMonth()+6);
  else if(recurrence==="annuel") d.setFullYear(d.getFullYear()+1);
  else return "";
  return d.toISOString().slice(0,10);
}

export function catColor(cat){
  const map={ juridique:THEME.red, contrat:THEME.amber, facture_recu:THEME.emerald, graphisme:THEME.purple, lore:THEME.gold, patchnote:THEME.accent, modelisation:THEME.purple, map_custom:THEME.accent, technique_infra:THEME.textMuted, reunion_cr:THEME.amber };
  return map[cat] || THEME.accent;
}

export function fileIcon(ext){ ext=(ext||"").toLowerCase().replace(".",""); if(["png","jpg","jpeg","gif","webp","svg"].includes(ext))return "🖼️"; if(ext==="pdf")return "📕"; if(["doc","docx"].includes(ext))return "📘"; if(["xls","xlsx","csv"].includes(ext))return "📗"; if(["zip","rar","7z"].includes(ext))return "🗜️"; if(["mp4","mov","webm"].includes(ext))return "🎬"; return "📄"; }
